"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDiffArray = exports.addPhonePrefix = exports.removePhonePrefix = void 0;
const removePhonePrefix = (number) => {
    if (number && number.includes("+91"))
        return number.split("+91")[1];
    return number;
};
exports.removePhonePrefix = removePhonePrefix;
const addPhonePrefix = (number) => {
    if (number && !number.includes("+91"))
        return "+91" + number;
    return number;
};
exports.addPhonePrefix = addPhonePrefix;
const isDiffArray = (arr1, arr2) => {
    // First check lengths - if different, return true immediately
    if (arr1.length !== arr2.length)
        return true;
    // Create copies to avoid modifying original arrays
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();
    // Compare elements until first difference
    return sorted1.some((element, index) => element !== sorted2[index]);
};
exports.isDiffArray = isDiffArray;
